import React from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import ModalSimple from '../../global/modal-simple';
import InfoIcon from './shared/info-icon';
import {IPromoObj} from '../../checkout/i';

declare var __promo_json: IPromoObj;

// Blocks both product page layouts show as they are: the backorder notice, the store's product message, the promo code note and
// the store's own content. Moved unchanged from the control layout (layout-a.tsx).

/** "Backordered Product" with the backorder text (s.pulse sets ui.is_bo, and hides Add To Cart). */
export const BackorderNotice: React.FC = observer(() => {
    if (!s.ui.is_bo) {
        return null;
    }
    return (
        <div
            className="alert alert-danger mt-2"
            role="alert"
        >
            <div className="b">Backordered Product</div>
            {s.ui.bo_msg}
        </div>
    );
});

/** The store's product message (Store_Products.StoreProductMessage). */
export const StoreProductMessageBlock: React.FC = observer(() => {
    if (!(s.prod && s.si && s.si.StoreProductMessage && s.si.StoreProductMessage.length > 0)) {
        return null;
    }
    return (
        <div className="gray-box">
            <div
                dangerouslySetInnerHTML={{
                    __html: s.si.StoreProductMessage,
                }}
            />
        </div>
    );
});

/** The product's promo code with its terms modal, when the store has no product message of its own. */
export const PromoBlock: React.FC = observer(() => {
    if (!(s.isRetail && __promo_json.hasPromo && __promo_json.promo && __promo_json.promo.length > 0 && !(s.prod && s.si && s.si.StoreProductMessage && s.si.StoreProductMessage.length > 0))) {
        return null;
    }
    return (
        <div>
            <ModalSimple
                id="modal-promo-code"
                title="Promo Code Terms"
            >
                <div>
                    <ul>
                        <li>
                            <div
                                className="ib"
                                dangerouslySetInnerHTML={{
                                    __html: __promo_json.promo,
                                }}
                            ></div>
                        </li>
                    </ul>
                    <hr></hr>
                    {__promo_json.modal1 !== '' && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: __promo_json.modal1,
                            }}
                        ></div>
                    )}
                    {__promo_json.modal1 !== '' && <hr />}

                    <div
                        dangerouslySetInnerHTML={{
                            __html: __promo_json.modal2,
                        }}
                    ></div>
                </div>
            </ModalSimple>
            <div className="discount-highlight-product-page">
                <div
                    style={{display: 'inline'}}
                    dangerouslySetInnerHTML={{
                        __html: __promo_json.promo,
                    }}
                ></div>
                <InfoIcon
                    id="modal-promo-code"
                    ariaLabel="Click here for more promotional information."
                    useMargin={true}
                    styleBlack={true}
                />
            </div>
        </div>
    );
});

/** The store's own content blocks (H2 1 to 4). */
export const StoreH2Content: React.FC = observer(() => {
    if (!(s.prod && !s.prod.IsCAF)) {
        return null;
    }
    return (
        <div
            className="row"
            id="store-h2"
        >
            <div className="col-12 text-left">
                {s.si && s.si.H2_1 !== '' && s.si.H2_1_Content !== '' && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<h2>${s.si.H2_1}</h2>${s.si.H2_1_Content}`,
                        }}
                    />
                )}
                {s.si && s.si.H2_2 !== '' && s.si.H2_2_Content !== '' && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<h2>${s.si.H2_2}</h2>${s.si.H2_2_Content}`,
                        }}
                    />
                )}
                {s.si && s.si.H2_3 !== '' && s.si.H2_3_Content !== '' && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<h2>${s.si.H2_3}</h2>${s.si.H2_3_Content}`,
                        }}
                    />
                )}
                {s.si && s.si.H2_4 !== '' && s.si.H2_4_Content !== '' && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<h2>${s.si.H2_4}</h2>${s.si.H2_4_Content}`,
                        }}
                    />
                )}
            </div>
        </div>
    );
});
